export const baseUrl = "";
export const apiBaseUrl = baseUrl + "/api/v1";
